import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';
import hiTranslations from './locales/hi.json';
import bnTranslations from './locales/bn.json';
import knTranslations from './locales/kn.json';
import paTranslations from './locales/pa.json';
import taTranslations from './locales/ta.json';
import teTranslations from './locales/te.json';
import mrTranslations from './locales/mr.json';
import guTranslations from './locales/gu.json';
import mlTranslations from './locales/ml.json';
import orTranslations from './locales/or.json';
import asTranslations from './locales/as.json';

const resources = {
  en: { translation: enTranslations },
  ar: { translation: arTranslations },
  hi: { translation: hiTranslations },
  bn: { translation: bnTranslations },
  kn: { translation: knTranslations },
  pa: { translation: paTranslations },
  ta: { translation: taTranslations },
  te: { translation: teTranslations },
  mr: { translation: mrTranslations },
  gu: { translation: guTranslations },
  ml: { translation: mlTranslations },
  or: { translation: orTranslations },
  as: { translation: asTranslations }
};

i18n
  .use(initReactI18next) // Initialize react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
